import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Refocus.scss';
export const Refocus = () => {
    const location = useLocation();
    const divRef = useRef(null);
    useEffect(() => {
        var _a;
        (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    return (React.createElement("div", { ref: divRef, tabIndex: -1, className: "refocus-tab-nav-fix" },
        "Navigerade till ",
        location.pathname));
};
